<template>
  <img :src="resolvedUrl" width=18 height=18 />
</template>

<script>
export default {

  name: 'LangIcon',
  props: {
    lang: { type: String, required: true }
  },

  data: () => ({ resolvedUrl: null }),

  watch: {
    lang: {
      async handler () {
        const mod = await import(`../../images/pages/api/${this.lang}.svg`);
        this.resolvedUrl = mod.default;
      },
      immediate: true
    }
  }

};
</script>
